import React from 'react'
import "./potency.scss"

//Imagens:
import PotencySmartphone from "../../../assets/reports/potencySmartphone.png";
import PotencyTablet from "../../../assets/reports/potencyTablet.png";
import { useTranslation } from 'react-i18next';

function Potency() {
  const { t } = useTranslation()

  return (
    <div className='container-potency'>
      <div className='title-potency'>
        <h1>{t("reports.potency.title")}</h1>
      </div>
      <div className='potency-texts'>
        <div className='potency-smartphone'>
          <img src={PotencySmartphone} alt="" />
          <p>{t("reports.potency.potency_smartphone.section_text_1")}</p>
          <p>{t("reports.potency.potency_smartphone.section_text_2")}</p>
        </div>
        <div className='potency-tablet'>
          <img src={PotencyTablet} alt="" />
          <p>{t("reports.potency.potency_tablet.section_text_1")}</p>
          <p>{t("reports.potency.potency_tablet.section_text_2")}</p>
          <p>{t("reports.potency.potency_tablet.section_text_3")}</p>
        </div>
      </div>
    </div>
  )
}

export default Potency